import { createIcon } from '@chakra-ui/icons';

export const Admin = createIcon({
  displayName: 'Admin',
  viewBox: '0 0 15 16',
  path: [
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.27273 16C3.23127 15.1018 0 11.2887 0 7.27273V2.90909L7.27273 0L14.5455 2.90909V7.27273C14.5455 11.2902 11.3142 15.1018 7.27273 16ZM1.45455 3.63636V7.27273C1.49611 8.95428 2.08754 10.5759 3.13831 11.8894C4.18909 13.2028 5.64132 14.1358 7.27273 14.5455C8.90414 14.1358 10.3564 13.2028 11.4071 11.8894C12.4579 10.5759 13.0493 8.95428 13.0909 7.27273V3.63636L7.27273 1.45455L1.45455 3.63636Z"
        fill="currentColor"
      />
      <path
        d="M7.27277 7.27284C8.27693 7.27284 9.09095 6.45881 9.09095 5.45466C9.09095 4.4505 8.27693 3.63647 7.27277 3.63647C6.26862 3.63647 5.45459 4.4505 5.45459 5.45466C5.45459 6.45881 6.26862 7.27284 7.27277 7.27284Z"
        fill="currentColor"
      />
      <path
        d="M3.63623 10.1818C3.9947 10.8351 4.5203 11.3813 5.15924 11.7647C5.79818 12.148 6.52752 12.3548 7.27259 12.3636C8.01767 12.3548 8.747 12.148 9.38595 11.7647C10.0249 11.3813 10.5505 10.8351 10.909 10.1818C10.8908 8.80291 8.47841 8 7.27259 8C6.06023 8 3.65441 8.80291 3.63623 10.1818Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
